import { createAsyncThunk } from "@reduxjs/toolkit";
import keywordApi from "api/keywordApi";
import { formatQueryParams } from "helpers/format";

export const getListRealTimeKeywordRecommend = createAsyncThunk("List Real Time Keyword Recommend", async (params: any = {}) => {
  try {
    const response = await keywordApi.realTimeKeywordRecommends(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
});

export const getListPopularKeywordRecommend = createAsyncThunk("List Popular Keyword Recommend", async (params: any = {}) => {
  try {
    const response = await keywordApi.popularKeywordRecommends(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
});